<style lang="scss">
  @import "../../../scss/variables";
</style>

<template>
  <div class="myo-paramters">

    <!-- ============= Beachflag ============= -->
    <div v-if="type == 'beachflag'">
      <md-input-container>
        <label for="shape">Form</label>
        <md-select name="shape" id="shape" v-model="parameters.shape">
          <md-option value="normal">Normal</md-option>
          <md-option value="drop">Dråpe</md-option>
        </md-select>
      </md-input-container>
      <md-input-container v-if="parameters.shape === 'normal'">
        <label for="size">Størrelse</label>
        <md-select name="size" id="size" v-model="parameters.size">
          <md-option value="small">Small (220 cm)</md-option>
          <md-option value="medium">Medium (265 cm)</md-option>
          <md-option value="large">Large (365 cm)</md-option>
          <md-option value="xl">XL (420 cm)</md-option>
        </md-select>
      </md-input-container>
      <md-input-container v-if="parameters.shape === 'drop'">
        <label for="size">Størrelse</label>
        <md-select name="size" id="size" v-model="parameters.size">
          <md-option value="small">Small (181 cm)</md-option>
          <md-option value="medium">Medium (208 cm)</md-option>
          <md-option value="large">Large (271 cm)</md-option>
          <md-option value="xl">XL (372 cm)</md-option>
        </md-select>
      </md-input-container>
    </div>

    <!-- ============= Banner ============= -->
    <div v-else-if="type == 'banner'">
      <div v-if="parameters.features">
        <md-input-container>
          <label for="size">Materiale</label>
          <md-select name="size" v-model="parameters.features.material">
            <md-option value="pvc">PVC</md-option>
            <md-option value="textile">Tekstil</md-option>
          </md-select>
        </md-input-container>
      </div>
      <md-input-container>
        <label for="shape">Bredde (cm)</label>
        <md-input type="number" v-model="parameters.width"></md-input>
      </md-input-container>
      <md-input-container>
        <label for="shape">Høyde (cm)</label>
        <md-input type="number" v-model="parameters.height"></md-input>
      </md-input-container>
      <div v-if="parameters.extra">
        <md-input-container>
          <label for="size">Maljer/hull</label>
          <md-select name="size" v-model="parameters.extra.holes">
            <md-option :value="true">Ja</md-option>
            <md-option :value="false">Nei</md-option>
          </md-select>
        </md-input-container>
        <md-input-container v-if="parameters.extra.holes">
          <label for="shape">Antall strikker (beregnes automatisk)</label>
          <md-input type="number" v-model="parameters.extra.rubber_bands" :disabled="true"></md-input>
        </md-input-container>
      </div>
    </div>

    <!-- ============= Flex Wall ============= -->
    <div v-else-if="type == 'flex-wall'">
      <div v-if="parameters.features">
        <md-input-container>
          <label for="size">Trykk duk</label>
          <md-select name="size" v-model="parameters.features.sides">
            <md-option value="single">En-sidig trykk</md-option>
            <md-option value="double">To-sidig trykk</md-option>
          </md-select>
        </md-input-container>
      </div>
      <div v-if="parameters.extra">
        <md-input-container>
          <label for="size">Med system</label>
          <md-select name="size" v-model="parameters.extra.system">
            <md-option :value="true">Ja</md-option>
            <md-option :value="false">Nei</md-option>
          </md-select>
        </md-input-container>
      </div>
      <md-input-container>
        <label for="shape">Bredde (cm)</label>
        <md-input type="number" v-model="parameters.width"></md-input>
      </md-input-container>
      <md-input-container>
        <label for="shape">Høyde (cm)</label>
        <md-input type="number" v-model="parameters.height"></md-input>
      </md-input-container>
    </div>

    <!-- ============= Curved Pop-up Wall ============= -->
    <div v-else-if="type == 'curved-pop-up-wall'">
      <md-input-container>
        <label for="size">Vegg</label>
        <md-select name="size" v-model="parameters.type">
          <md-option value="curved">POP-up vegg 225x350 cm</md-option>
        </md-select>
      </md-input-container>
    </div>

    <!-- ============= Curved Pop-up Wall ============= -->
    <div v-else-if="type == 'expo-tent'">
      <md-input-container>
        <label for="size">Vegg</label>
        <md-select name="size" v-model="parameters.type">
          <md-option value="300x300">EXPO-telt 300x300 cm</md-option>
        </md-select>
      </md-input-container>
    </div>

    <!-- ============= Curved Pop-up Wall ============= -->
    <div v-else-if="type == 'digital-booklet'">
      <md-input-container>
        <label for="shape">Antall sider</label>
        <md-input type="number" v-model="parameters.pages"></md-input>
      </md-input-container>
    </div>

    <!-- ============= Alu Frame ============= -->
    <div v-else-if="type == 'alu-frame'">
      <md-input-container>
        <label for="size">Størrelse</label>
        <md-select name="size" id="size" v-model="parameters.size">
          <md-option value="A4">A4</md-option>
          <md-option value="A3">A3</md-option>
          <md-option value="A2">A2</md-option>
          <md-option value="A1">A1</md-option>
          <md-option value="50x50">50x50 cm</md-option>
          <md-option value="60x60">60x60 cm</md-option>
          <md-option value="60x80">60x80 cm</md-option>
          <md-option value="70x100">70x100 cm</md-option>
          <md-option value="100x150">100x150 cm</md-option>
          <md-option value="100x200">100x200 cm</md-option>
          <md-option value="300x300">300x300 cm</md-option>
        </md-select>
      </md-input-container>
    </div>

    <!-- ============= L-Banner ============= -->
    <div v-else-if="type == 'l-banner'">
      <md-input-container>
        <label for="size">Type</label>
        <md-select name="size" id="type" v-model="parameters.type">
          <md-option value="single-75x200">Enkel 75x200 cm</md-option>
          <md-option value="single-90x200">Enkel 90x200 cm</md-option>
          <md-option value="double-90x200">Dobbel 90x200 cm</md-option>
        </md-select>
      </md-input-container>
    </div>

    <!-- ============= L-Banner Graphics ============= -->
    <div v-else-if="type == 'l-banner-graphics'">
      <md-input-container>
        <label for="size">Størrelse</label>
        <md-select name="size" id="type" v-model="parameters.size">
          <md-option value="75x200">75x200 cm</md-option>
          <md-option value="90x200">90x200 cm</md-option>
        </md-select>
      </md-input-container>
    </div>

    <!-- ============= X-Banner ============= -->
    <div v-else-if="type == 'x-banner'">
      <md-input-container>
        <label for="size">Størrelse</label>
        <md-select name="size" id="type" v-model="parameters.size">
          <md-option value="80x180">80x180 cm</md-option>
          <md-option value="90x210">90x210 cm</md-option>
        </md-select>
      </md-input-container>
    </div>

    <!-- ============= X-Banner Graphics ============= -->
    <div v-else-if="type == 'x-banner-graphics'">
      <md-input-container>
        <label for="size">Størrelse</label>
        <md-select name="size" id="type" v-model="parameters.size">
          <md-option value="80x180">80x180 cm</md-option>
          <md-option value="90x210">90x210 cm</md-option>
        </md-select>
      </md-input-container>
    </div>

    <!-- ============= Canvas ============= -->
    <div v-else-if="type == 'canvas'">
      <md-input-container>
        <label for="size">Størrelse</label>
        <md-select name="size" v-model="parameters.size">
          <md-option value="A4">A4</md-option>
          <md-option value="A3">A3</md-option>
          <md-option value="A2">A2</md-option>
          <md-option value="A1">A1</md-option>
          <md-option value="50x50">50x50</md-option>
          <md-option value="60x60">60x60</md-option>
          <md-option value="70x100">70x100</md-option>
        </md-select>
      </md-input-container>
    </div>

    <!-- ============= Alu-plate ============= -->
    <div v-else-if="type == 'alu-plate'">
      <div v-if="parameters.features">
        <md-input-container>
          <label for="size">Tykkelse</label>
          <md-select name="size" v-model="parameters.features.thickness">
            <md-option value="3">3 mm</md-option>
          </md-select>
        </md-input-container>
      </div>
      <md-input-container>
        <label for="shape">Bredde (cm)</label>
        <md-input type="number" v-model="parameters.width"></md-input>
      </md-input-container>
      <md-input-container>
        <label for="shape">Høyde (cm)</label>
        <md-input type="number" v-model="parameters.height"></md-input>
      </md-input-container>
      <div v-if="parameters.extra">
        <md-input-container>
          <label for="size">Formskjæring</label>
          <md-select name="size" v-model="parameters.extra.cut_to_shape">
            <md-option :value="true">Ja</md-option>
            <md-option :value="false">Nei</md-option>
          </md-select>
        </md-input-container>
        <md-input-container>
          <label for="size">Hulling</label>
          <md-select name="size" v-model="parameters.extra.holes">
            <md-option :value="true">Ja</md-option>
            <md-option :value="false">Nei</md-option>
          </md-select>
        </md-input-container>
      </div>
    </div>

    <!-- ============= PVC-plate ============= -->
    <div v-else-if="type == 'pvc-plate'">
      <div v-if="parameters.features">
        <md-input-container>
          <label for="size">Tykkelse</label>
          <md-select name="size" v-model="parameters.features.thickness">
            <md-option value="3">3 mm</md-option>
            <md-option value="5">5 mm</md-option>
            <md-option value="10">10 mm</md-option>
          </md-select>
        </md-input-container>
      </div>
      <md-input-container>
        <label for="shape">Bredde (cm)</label>
        <md-input type="number" v-model="parameters.width"></md-input>
      </md-input-container>
      <md-input-container>
        <label for="shape">Høyde (cm)</label>
        <md-input type="number" v-model="parameters.height"></md-input>
      </md-input-container>
      <div v-if="parameters.extra">
        <md-input-container>
          <label for="size">Hulling</label>
          <md-select name="size" v-model="parameters.extra.holes">
            <md-option :value="true">Ja</md-option>
            <md-option :value="false">Nei</md-option>
          </md-select>
        </md-input-container>
        <md-input-container>
          <label for="size">Formskjæring</label>
          <md-select name="size" v-model="parameters.extra.cut_to_shape">
            <md-option :value="true">Ja</md-option>
            <md-option :value="false">Nei</md-option>
          </md-select>
        </md-input-container>
      </div>
    </div>

    <div v-else>
      <div class="p2 rounded bg-light-grey">
        Dette produktet trenger ikke å tilpasses.
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props: {
      type: {},
    },

    data() {
      return {
        parameters: {},
      };
    },

    mounted() {
      this.initParameters();
      this.$emit('loaded');
    },

    methods: {
      initParameters() {
        switch (this.type) {
        case 'beachflag':
          this.parameters = {
            size: 'medium',
            shape: 'normal',
          };
          break;

        case 'banner':
          this.parameters = {
            width: '100',
            height: '100',
            features: {
              material: 'pvc',
            },
            extra: {
              holes: false,
              rubber_bands: 0,
            },
          };
          break;

        case 'alu-plate':
          this.parameters = {
            width: '100',
            height: '100',
            features: {
              thickness: '3',
            },
            extra: {
              holes: false,
              cut_to_shape: false,
            },
          };
          break;

        case 'pvc-plate':
          this.parameters = {
            width: '100',
            height: '100',
            features: {
              thickness: '3',
            },
            extra: {
              holes: false,
              cut_to_shape: false,
            },
          };
          break;

        case 'flex-wall':
          this.parameters = {
            width: '130',
            height: '81',
            features: {
              sides: 'single',
            },
            extra: {
              system: true,
            },
          };
          break;

        case 'curved-pop-up-wall':
          this.parameters = {
            type: 'curved',
          };
          break;

        case 'digital-booklet':
          this.parameters = {
            pages: 8,
          };
          break;

        case 'expo-tent':
          this.parameters = {
            type: '300x300',
          };
          break;

        case 'alu-frame':
          this.parameters = {
            size: 'A4',
          };
          break;

        case 'l-banner':
          this.parameters = {
            type: 'single-75x200',
          };
          break;

        case 'l-banner-graphics':
          this.parameters = {
            size: '75x200',
          };
          break;

        case 'x-banner':
          this.parameters = {
            size: '80x180',
          };
          break;

        case 'canvas':
          this.parameters = {
            size: 'A4',
          };
          break;

        case 'x-banner-graphics':
          this.parameters = {
            size: '80x180',
          };
          break;

        default:
          this.parameters = {};
          break;
        }
      },

      updateExtra() {
        if (this.type === 'banner') {
          if (this.parameters.extra.holes) {
            let rubberBands = (Math.ceil(this.parameters.width / 100) + 1) * 2;
            console.log(rubberBands);
            rubberBands += (Math.ceil(this.parameters.height / 100) - 1) * 2;
            console.log(rubberBands);
            this.parameters.extra.rubber_bands = rubberBands;
          } else {
            this.parameters.extra.rubber_bands = 0;
          }
        }

        if (this.type === 'banner') {
          if (this.parameters.extra.holes) {
            let rubberBands = (Math.ceil(this.parameters.width / 100) + 1) * 2;
            console.log(rubberBands);
            rubberBands += (Math.ceil(this.parameters.height / 100) - 1) * 2;
            console.log(rubberBands);
            this.parameters.extra.rubber_bands = rubberBands;
          } else {
            this.parameters.extra.rubber_bands = 0;
          }
        }
      },
    },

    watch: {
      parameters: {
        deep: true,
        handler(value) {
          this.$emit('changed', value);
        },
      },
      'parameters.width': {
        handler(value) {
          this.updateExtra();
        },
      },
      'parameters.height': {
        handler(value) {
          this.updateExtra();
        },
      },
      'parameters.extra.holes': {
        handler(value) {
          this.updateExtra();
        },
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Parameters.vue?37508469